"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDefaultLanguage = getDefaultLanguage;
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _stringUtils = require("./string-utils");

const SUPPORT_LANGUAGES = ['zh-CA', 'en-US'];
const DEFAULT_LANGUAGE = 'en-US';
const __CACHEKEY = '__lang';
/**
 * 获取默认浏览器语言
 * @returns
 */

function getDefaultLanguage() {
  let language = localStorage.getItem(__CACHEKEY) || ''; // 有缓存优先使用缓存

  if (language) {
    return language;
  } // 获取本地语言


  language = navigator.language; // 未获取到语言，返回默认语言

  if (!language) return DEFAULT_LANGUAGE;
  language = language.toLowerCase().replace('_', '-');
  if (/-(\w{2})$/.test(language)) language = language.replace(/(\w{2})$/, RegExp.$1.toUpperCase()); // 如果支持获取到的语言则返回

  if (SUPPORT_LANGUAGES.indexOf(language) !== -1) return language;
  return DEFAULT_LANGUAGE;
}
/**
 * 国际化
 * 支持语言资源异步加载
 *
 * @class Globalize
 */


class Globalize {
  constructor() {
    (0, _defineProperty2.default)(this, "currentLan", void 0);
    (0, _defineProperty2.default)(this, "localeLoaders", void 0);
    (0, _defineProperty2.default)(this, "__listeners", void 0);
    (0, _defineProperty2.default)(this, "__lanResource", new Map());
    this.currentLan = getDefaultLanguage();
    this.__listeners = {};
  }
  /**
   * 事件触发
   * @param type
   * @param param
   * @returns
   */


  emit(type, ...rest) {
    if (!this.__listeners[type]) return;
    const fns = this.__listeners[type];
    fns.forEach(fn => {
      fn(...rest);
    });
  }
  /**
   * 添加事件
   * @param type
   * @param cb
   * @returns
   */


  on(type, cb) {
    if (!this.__listeners[type]) {
      this.__listeners[type] = [cb];
      return;
    }

    this.__listeners[type].push(cb);
  }
  /**
   * 判断指定的locale资源是否已经准备好
   *
   * @param [locale] (description)
   * @returns (description)
   */


  isResourceReady(locale) {
    return !!this.__lanResource.get(locale);
  }
  /**
   * 设置locale
   *
   * @param locale (description)
   * @returns (description)
   */


  async setLocale(locale) {
    const curLocale = this.currentLan || getDefaultLanguage();
    this.currentLan = locale;

    if (this.isResourceReady(locale)) {
      localStorage.setItem(__CACHEKEY, this.currentLan);
      this.emit('localechange', locale, curLocale);
      return Promise.resolve(locale);
    }

    const resource = await this.loadResource(locale);
    this.emit('localechange', locale, curLocale);
    return resource;
  }
  /**
   * 设置locale资源加载器
   *
   * {
   *   localeStr1 : Function return promise
   *   localeStr2 : Function return promise
   * }
   *
   * @param localeLoaders (description)
   */


  setLocaleLoaders(localeLoaders) {
    this.localeLoaders = localeLoaders;
  }
  /**
   * 加载locale资源
   *
   * @param [locale] (description)
   * @returns (description)
   */


  async loadResource(locale = 'en-US') {
    try {
      let resource = null; // 不存在走默认

      if (!this.localeLoaders[locale]) {
        locale = Object.keys(this.localeLoaders)[0];
      }

      resource = await this.localeLoaders[locale](); // 更新缓存

      localStorage.setItem(__CACHEKEY, locale);

      this.__lanResource.set(locale, resource);

      return Promise.resolve(resource);
    } catch (e) {
      return Promise.reject('load locale resource failed');
    }
  }
  /**
   * 获取MessagesGetter
   *
   * @param namespace (description)
   * @param locale (语言)
   * @returns Function MessagesGetter
   */


  getMessages(namespace, locale) {
    return (key, args) => {
      try {
        const messages = (this.__lanResource.get(locale || this.currentLan) || {})[namespace];
        if (!messages[key]) return key;
        return (0, _stringUtils.template)(messages[key], args);
      } catch (e) {
        return key;
      }
    };
  }
  /**
   * 判断当前的locale资源是否已经加载完毕
   *
   * @returns (description)
   */


  async ready() {
    const locale = this.currentLan;
    if (this.isResourceReady(locale)) return Promise.resolve(true);

    try {
      await this.loadResource(locale);
      return Promise.resolve(true);
    } catch (e) {
      await this.loadResource('en-US');
      return Promise.resolve(true);
    }
  }

}

const i18n = new Globalize();
var _default = i18n;
exports.default = _default;